/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxFrontOpenIcon20Solid = forwardRef('DeliveryBoxFrontOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m.572 6.343 1.11-3.22A1.667 1.667 0 0 1 3.257 2H12l-1.318 4.777A1.667 1.667 0 0 1 9.076 8H1.753A1.25 1.25 0 0 1 .572 6.343Z" }),
        React.createElement("path", { d: "m12 2 1.205 4.744A1.667 1.667 0 0 0 14.82 8h3.472a1.25 1.25 0 0 0 1.191-1.628l-1.019-3.21A1.667 1.667 0 0 0 16.876 2H12Z" }),
        React.createElement("path", { d: "M11.25 8.38c-.309.382-.78.62-1.297.62H2v5a3 3 0 0 0 3 3h6.25V8.38Z" }),
        React.createElement("path", { d: "M12.75 17H15a3 3 0 0 0 3-3V9h-4.034c-.474 0-.91-.2-1.216-.527V17Z" })));
});
